import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e26a382&scoped=true&"
import script from "./Taxi.ts?vue&type=script&lang=ts&"
export * from "./Taxi.ts?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=2e26a382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e26a382",
  null
  
)

export default component.exports